var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBankingName(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1488_3040)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.4546 9.8182C23.7561 9.8182 24.0001 9.57571 24.0001 9.27426V7.09268C24.0001 6.9004 23.8989 6.72199 23.7332 6.62396L13.0488 0.278906C12.3856 -0.0886113 11.6378 -0.0998101 10.9362 0.286372L0.266881 6.62396C0.101199 6.72194 0 6.9004 0 7.09268V9.27426C0 9.57571 0.243972 9.8182 0.545472 9.8182H2.18184V19.6368C0.978495 19.6368 0 20.6152 0 21.8184V23.4546C0 23.7561 0.243972 24.0001 0.545472 24.0001H23.4546C23.7561 24.0001 24.0001 23.7561 24.0001 23.4546V21.8184C24.0001 20.6152 23.0216 19.6368 21.8182 19.6368V9.8182H23.4546ZM9.81819 19.6364H6.54546V9.8182H9.81819V19.6364ZM11.999 7.63912C10.7951 7.63912 9.81604 6.66017 9.81604 5.45647C9.81604 4.25277 10.7951 3.27381 11.999 3.27381C13.2028 3.27381 14.1818 4.25277 14.1818 5.45647C14.1818 6.66017 13.2028 7.63912 11.999 7.63912ZM17.4545 19.6364H14.1818V9.8182H17.4545V19.6364Z",
    fill: "#4F565E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1488_3040"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankingName);
export default __webpack_public_path__ + "static/media/banking-name.5bd36a9d4602024d3d7e4f819b332f98.svg";
export { ForwardRef as ReactComponent };